
import Vue from 'vue';

export default Vue.extend({
    name: 'Progress',
    props: {
        value: {
            type: Number,
            default: 0,
            required: true,
        },
        max: {
            type: Number,
            default: 1,
        },
    },
    computed: {
        progress(): number {
            return (this.value / this.max) * 100;
        },
    },
});
